var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPatten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 86,
    viewBox: "0 0 768 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_28749)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8115 -7.58252L92.5977 9.38609L82.8115 26.3547L63.2393 26.3547L53.3633 9.38608L63.2393 -7.58252L82.8115 -7.58252Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8115 34.9736L92.5977 51.9423L82.8115 68.9109L63.2393 68.9109L53.3633 51.9423L63.2393 34.9736L82.8115 34.9736Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.171 9.1167L186.957 26.0853L177.171 43.0539L157.599 43.0539L147.723 26.0853L157.599 9.1167L177.171 9.1167Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2705 14.0552L56.0566 31.0238L46.2705 47.9924L26.6085 47.9924L16.8223 31.0238L26.6085 14.0552L46.2705 14.0552Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.811 -5.58203L699.597 11.3866L689.811 28.3552L670.238 28.3552L660.362 11.3866L670.238 -5.58203L689.811 -5.58203Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.812 36.9741L699.598 53.9427L689.812 70.9113L670.239 70.9113L660.363 53.9427L670.239 36.9741L689.812 36.9741Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.171 11.1167L793.957 28.0853L784.171 45.0539L764.599 45.0539L754.723 28.0853L764.599 11.1167L784.171 11.1167Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.448 22.7891L598.234 39.7577L588.448 56.7263L568.876 56.7263L559 39.7577L568.876 22.7891L588.448 22.7891Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.271 16.0552L663.057 33.0238L653.271 49.9924L633.608 49.9924L623.822 33.0238L633.608 16.0552L653.271 16.0552Z",
    stroke: "#FF6B00",
    strokeWidth: 0.89781,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_28749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPatten);
export default __webpack_public_path__ + "static/media/login-patten.5f531b3d89bb370b5a8af8d8f1dce920.svg";
export { ForwardRef as ReactComponent };